import React from "react";

export default () => <i className={"sprite sprite-edit-cancel"} />;
